import { selectedPlanType } from '../../../../admin/src/app/interfaceTypes';
import { Plan } from '../../generated';

export interface PAuthState {
  bottom: boolean;
  enabled: boolean;
  yearlyPaymentValue: boolean;
  monthlyPayment: string;
  yearlyPayment: string;
  basicContacts: number;
  standardContacts: number;
  isFree: boolean;
  freePriceId: string;
  monthlyPriceId: string;
  yearlyPriceId: string;
  plans: Plan[];
  changePlanAction: boolean;
  selectedPlanValue: selectedPlanType;
  selectedPlan: Plan | null;
  freePlanUsed?: boolean;
  subscribedPlanId?: string;
}

export const PAuthInitialState: PAuthState = {
  bottom: false,
  enabled: false,
  yearlyPaymentValue: false,
  monthlyPayment: '3.00',
  yearlyPayment: '19.00',
  basicContacts: 1,
  standardContacts: 5,
  isFree: false,
  freePriceId: '',
  monthlyPriceId: '',
  yearlyPriceId: '',
  plans: [],
  changePlanAction: false,
  selectedPlanValue: 'month',
  selectedPlan: null,
  freePlanUsed: false,
  subscribedPlanId: ''
};

export enum PAuthActionType {
  SET_BOTTOM = 'setBottom',
  SET_ENABLED = 'setEnabled',
  SET_YEARLY_PAYMENT_VALUE = 'setYearlyPaymentValue',
  SET_MONTHLY_PAYMENT = 'setMonthlyPayment',
  SET_YEARLY_PAYMENT = 'setYearlyPayment',
  SET_BASIC_CONTACTS = 'setBasicContacts',
  SET_STANDARD_CONTACTS = 'setStandardContacts',
  SET_IS_FREE = 'setIsFree',
  SET_FREE_PRICE_ID = 'setFreePriceId',
  SET_MONTHLY_PRICE_ID = 'setMonthlyPriceId',
  SET_YEARLY_PRICE_ID = 'setYearlyPriceId',
  SET_PLANS = 'setPlans',
  SET_CHANGE_PLAN_ACTION = 'setChangePlanAction',
  SET_SELECTED_PLAN_VALUE = 'setSelectedPlanValue',
  SET_SELECTED_PLAN = 'setSelectedPlan',
  SET_FREE_PLAN_USED = 'setFreePlanUsed',
  SET_SUBSCRIBED_PLAN_ID = 'setSubscribedPlanId'
}

export type PAuthAction =
  | { type: PAuthActionType.SET_BOTTOM; bottom: boolean }
  | { type: PAuthActionType.SET_ENABLED; enabled: boolean }
  | { type: PAuthActionType.SET_YEARLY_PAYMENT_VALUE; yearlyPaymentValue: boolean }
  | { type: PAuthActionType.SET_MONTHLY_PAYMENT; monthlyPayment: string }
  | { type: PAuthActionType.SET_YEARLY_PAYMENT; yearlyPayment: string }
  | { type: PAuthActionType.SET_BASIC_CONTACTS; basicContacts: number }
  | { type: PAuthActionType.SET_STANDARD_CONTACTS; standardContacts: number }
  | { type: PAuthActionType.SET_IS_FREE; isFree: boolean }
  | { type: PAuthActionType.SET_FREE_PRICE_ID; freePriceId: string }
  | { type: PAuthActionType.SET_MONTHLY_PRICE_ID; monthlYPriceId: string }
  | { type: PAuthActionType.SET_YEARLY_PRICE_ID; yearlyPriceId: string }
  | { type: PAuthActionType.SET_PLANS; plans: Plan[] }
  | { type: PAuthActionType.SET_CHANGE_PLAN_ACTION; changePlanAction: boolean }
  | { type: PAuthActionType.SET_SELECTED_PLAN_VALUE; selectedPlanValue: selectedPlanType }
  | { type: PAuthActionType.SET_FREE_PLAN_USED; freePlanUsed: boolean }
  | { type: PAuthActionType.SET_SUBSCRIBED_PLAN_ID; subscribedPlanId: string }
  | { type: PAuthActionType.SET_SELECTED_PLAN; selectedPlan: Plan | null };

export const PAuthReducer = (state: PAuthState, action: PAuthAction): PAuthState => {
  switch (action.type) {
    case PAuthActionType.SET_BOTTOM:
      return {
        ...state,
        bottom: action.bottom
      };

    case PAuthActionType.SET_ENABLED:
      return {
        ...state,
        enabled: action.enabled
      };

    case PAuthActionType.SET_YEARLY_PAYMENT_VALUE:
      return {
        ...state,
        yearlyPaymentValue: action.yearlyPaymentValue
      };

    case PAuthActionType.SET_MONTHLY_PAYMENT:
      return {
        ...state,
        monthlyPayment: action.monthlyPayment
      };

    case PAuthActionType.SET_YEARLY_PAYMENT:
      return {
        ...state,
        yearlyPayment: action.yearlyPayment
      };

    case PAuthActionType.SET_BASIC_CONTACTS:
      return {
        ...state,
        basicContacts: action.basicContacts
      };

    case PAuthActionType.SET_STANDARD_CONTACTS:
      return {
        ...state,
        standardContacts: action.standardContacts
      };

    case PAuthActionType.SET_IS_FREE:
      return {
        ...state,
        isFree: action.isFree
      };

    case PAuthActionType.SET_FREE_PRICE_ID:
      return {
        ...state,
        freePriceId: action.freePriceId
      };

    case PAuthActionType.SET_MONTHLY_PRICE_ID:
      return {
        ...state,
        monthlyPriceId: action.monthlYPriceId
      };

    case PAuthActionType.SET_YEARLY_PRICE_ID:
      return {
        ...state,
        yearlyPriceId: action.yearlyPriceId
      };

    case PAuthActionType.SET_PLANS:
      return {
        ...state,
        plans: action.plans
      };

    case PAuthActionType.SET_CHANGE_PLAN_ACTION:
      return {
        ...state,
        changePlanAction: action.changePlanAction
      };

    case PAuthActionType.SET_SELECTED_PLAN_VALUE:
      return {
        ...state,
        selectedPlanValue: action.selectedPlanValue
      };

    case PAuthActionType.SET_SELECTED_PLAN:
      return {
        ...state,
        selectedPlan: action.selectedPlan
      };

    case PAuthActionType.SET_FREE_PLAN_USED:
      return {
        ...state,
        freePlanUsed: action.freePlanUsed
      };

    case PAuthActionType.SET_SUBSCRIBED_PLAN_ID:
      return {
        ...state,
        subscribedPlanId: action.subscribedPlanId
      };

    default:
      return state;
  }
};
